import {Pipe, PipeTransform} from '@angular/core';
import {CourseService} from '@app/@core/services/course.service';

@Pipe({
    name: 'courseName'
})
export class CourseNamePipe implements PipeTransform {


    constructor(private courseService: CourseService) {
    }

    transform(courseId: string): unknown {
        return courseId ? this.courseService.getName(courseId) : courseId;
    }
}
